const pgcetmbaComputerAwareness = [
  {
    id: 1,
    question: "Choose the word closest in meaning to: METICULOUS",
    options: ["A. Careless", "B. Painstaking", "C. Hasty", "D. Vague"],
    answer: "B"
  },
  {
    id: 2,
    question: "Choose the word opposite in meaning to: BENEVOLENT",
    options: ["A. Generous", "B. Kind", "C. Malevolent", "D. Charitable"],
    answer: "C"
  },
  {
    id: 3,
    question: "Choose the correctly spelt word.",
    options: ["A. Occurence", "B. Occurrance", "C. Occurrence", "D. Ocurrence"],
    answer: "C"
  },
  {
    id: 4,
    question: "Fill in the blank: The manager insisted _____ completing the report by Friday.",
    options: ["A. on", "B. at", "C. for", "D. with"],
    answer: "A"
  },
  {
    id: 5,
    question: "Choose the passive form of: \"The board will announce the results tomorrow.\"",
    options: [
      "A. The results will be announced by the board tomorrow.",
      "B. The results were announced by the board tomorrow.",
      "C. The results are announced by the board tomorrow.",
      "D. The results have been announced by the board tomorrow."
    ],
    answer: "A"
  },
  {
    id: 6,
    question: "Choose the correct meaning of the idiom: \"to bite the bullet\"",
    options: [
      "A. To avoid a difficulty",
      "B. To face a difficult situation bravely",
      "C. To speak rudely",
      "D. To eat quickly"
    ],
    answer: "B"
  },
  {
   id : 7,
   question : "Identify the part with an error: \"One of my colleagues (A) / has already submitted (B) / their report (C) / to the director (D).\"",
   options : ["A. A", "B. B", "C. C", "D. D"],
   answer : "C"
  },
  {
    id: 8,
    question: "Choose the sentence which is grammatically correct.",
    options: [
      "A. Each of the employees have their own desk.",
      "B. Each of the employees has their own desk.",
      "C. Each of the employees has his own desk.",
      "D. Each of the employee has his own desk."
    ],
    answer: "C"
  },
  {
    id: 9,
    question: "Fill in the blank: Had she studied harder, she _____ the exam.",
    options: ["A. would pass", "B. will pass", "C. would have passed", "D. had passed"],
    answer: "C"
  },
  {
    id: 10,
    question: "Who wrote the novel \"Wuthering Heights\"?",
    options: ["A. Jane Austen", "B. Emily Bronte", "C. Charlotte Bronte", "D. George Eliot"],
    answer: "B"
  },
  {
    id: 11,
    question: "Choose the correct one-word substitute for: \"A person who is unable to pay debts.\"",
    options: ["A. Miser", "B. Insolvent", "C. Philanthropist", "D. Ascetic"],
    answer: "B"
  },
  {
    id: 12,
    question: "Select the option with the most logical sequence: I. and submitted it before the deadline / II. She researched the topic thoroughly / III. then drafted the report / IV. and finally reviewed it twice",
    options: ["A. II-III-IV-I", "B. I-II-III-IV", "C. II-IV-III-I", "D. III-II-I-IV"],
    answer: "A"
  },
  {
    id: 13,
    question: "Choose the correct form: \"Neither the manager nor the employees _____ satisfied with the outcome.\"",
    options: ["A. is", "B. was", "C. were", "D. has been"],
    answer: "C"
  },
  {
    id: 14,
    question: "Choose the antonym of TRANSPARENT.",
    options: ["A. Clear", "B. Obscure", "C. Evident", "D. Lucid"],
    answer: "B"
  },
  {
    id: 15,
    question: "Choose the correctly punctuated sentence.",
    options: [
      "A. \"Where is the report,\" he asked.",
      "B. \"Where is the report?\" he asked.",
      "C. \"Where is the report\"? he asked.",
      "D. Where is the report? he asked.\""
    ],
    answer: "B"
  },
  {
    id: 16,
    question: "Fill in the blank with the appropriate preposition: The company is known _____ its quality service.",
    options: ["A. for", "B. with", "C. by", "D. at"],
    answer: "A"
  },
  {
    id: 17,
    question: "Choose the correct passive voice: \"They will have completed the audit by June.\"",
    options: [
      "A. The audit will have been completed by them by June.",
      "B. The audit was completed by them by June.",
      "C. The audit is being completed by them by June.",
      "D. The audit had been completed by them by June."
    ],
    answer: "A"
  },
  {
    id: 18,
    question: "Choose the correct meaning of the phrase \"to cut corners\":",
    options: [
      "A. To take a shortcut, often sacrificing quality",
      "B. To finish work early",
      "C. To argue with someone",
      "D. To travel a long distance"
    ],
    answer: "A"
  },
  {
    id: 19,
    question: "Match the following authors with their works: List-I: (a) Charles Dickens (b) Leo Tolstoy (c) Mark Twain (d) Thomas Hardy / List-II: (i) War and Peace (ii) Tess of the d'Urbervilles (iii) Great Expectations (iv) The Adventures of Tom Sawyer",
    options: [
      "A. a-iii, b-i, c-iv, d-ii",
      "B. a-i, b-iii, c-ii, d-iv",
      "C. a-iv, b-ii, c-i, d-iii",
      "D. a-ii, b-iv, c-iii, d-i"
    ],
    answer: "A"
  },
  {
    id: 20,
    question: "Choose the sentence that best corrects the error: \"The data was collected and analysed by the researchers.\"",
    options: [
      "A. The data were collected and analysed by the researchers.",
      "B. The data was collect and analyse by the researchers.",
      "C. The datas were collected and analysed by the researchers.",
      "D. No correction required."
    ],
    answer: "A"
  }

];
 
export default pgcetmbaComputerAwareness;